(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("react"), require("react-dom"));
	else if(typeof define === 'function' && define.amd)
		define("Onairos", ["React", "ReactDOM"], factory);
	else if(typeof exports === 'object')
		exports["Onairos"] = factory(require("react"), require("react-dom"));
	else
		root["Onairos"] = factory(root["React"], root["ReactDOM"]);
})(this, (__WEBPACK_EXTERNAL_MODULE__639__, __WEBPACK_EXTERNAL_MODULE__346__) => {
return 